import { useCallback } from 'react';
import { notification } from 'antd';
import {
  useGetWorksheetQuery,
  useUpdateWorksheetMutation,
} from '@/state/slices/reports';
import { useWorksheetEditorState } from '../hooks/useWorksheetEditorState';
import { EditorShell } from './EditorShell';

interface WorksheetEditorProps {
  uuid: string;
}

export function WorksheetEditor({ uuid }: WorksheetEditorProps) {
  const { data, isLoading, error } = useGetWorksheetQuery(uuid);
  const [updateWorksheet, { isLoading: isSaving }] =
    useUpdateWorksheetMutation();

  const editor = useWorksheetEditorState(data);
  const { getPayload, markSaved } = editor;

  const handleSave = useCallback(async () => {
    const payload = getPayload();
    if (!payload) return;
    try {
      markSaved(await updateWorksheet(payload).unwrap(), payload);
      notification.success({ title: 'Worksheet saved' });
    } catch (err) {
      notification.error({
        title: 'Failed to save worksheet',
        description: (err as { data?: { name?: string[] } })?.data?.name?.[0],
      });
    }
  }, [getPayload, updateWorksheet, markSaved]);

  return (
    <EditorShell
      editor={editor}
      isLoading={isLoading}
      hasError={Boolean(error)}
      loadErrorTitle="Failed to load worksheet"
      isSaving={isSaving}
      onSave={handleSave}
    />
  );
}
